/**
 * Projects Block JavaScript
 */

(function () {
  "use strict";

  function getAjaxUrl(resultsEl) {
    const dataUrl = resultsEl.dataset.ajaxUrl;
    if (dataUrl) {
      return dataUrl;
    }
    if (window.sojTheme && window.sojTheme.ajaxUrl) {
      return window.sojTheme.ajaxUrl;
    }
    return "/wp-admin/admin-ajax.php";
  }

  function initProjects() {
    const blocks = document.querySelectorAll(".projects");

    blocks.forEach((block) => {
      const results = block.querySelector(".projects__results");
      const list = results
        ? results.querySelector("[data-projects-columns]")
        : null;
      const emptyMessage = results
        ? results.querySelector("[data-empty-message]")
        : null;
      const plantingSelect = block.querySelector(
        '.projects__filter-select[data-filter="planting"]'
      );
      const sectorSelect = block.querySelector(
        '.projects__filter-select[data-filter="sector"]'
      );

      if (!results || !list || (!plantingSelect && !sectorSelect)) {
        return;
      }

      const nonce = results.dataset.nonce;
      const action = results.dataset.action || "soj_filter_projects";
      const ajaxUrl = getAjaxUrl(results);

      const setEmptyState = (hasResults) => {
        if (!emptyMessage) {
          return;
        }
        emptyMessage.classList.toggle("is-hidden", !!hasResults);
      };

      const applyParallax = () => {
        if (!window.gsap || !window.ScrollTrigger) {
          return;
        }

        const columns = block.querySelectorAll(".projects__column");

        columns.forEach((column) => {
          const existingId = column.dataset.parallaxTriggerId;
          if (existingId) {
            const existingTrigger = window.ScrollTrigger.getById(existingId);
            if (existingTrigger) {
              existingTrigger.kill();
            }
            delete column.dataset.parallaxTriggerId;
          }

          const index = parseInt(column.dataset.columnIndex || "1", 10);
          const maxOffset = index === 2 ? 140 : 0;

          const triggerId = `projects-parallax-${Date.now()}-${Math.random()
            .toString(16)
            .slice(2)}`;

          const setY = window.gsap.quickSetter(column, "y", "px");
          window.gsap.set(column, { y: 0 });

          const trigger = window.ScrollTrigger.create({
            id: triggerId,
            trigger: column,
            start: "top bottom",
            end: "bottom top",
            scrub: true,
            onUpdate: (self) => {
              const eased = Math.sin(self.progress * Math.PI);
              setY(-maxOffset * eased);
            },
            onKill: () => setY(0),
          });

          column.dataset.parallaxTriggerId = triggerId;
        });

        window.ScrollTrigger.refresh();
      };

      const handleError = (error) => {
        console.error("[BLOCK] projects filter error:", error);
        if (emptyMessage) {
          emptyMessage.classList.remove("is-hidden");
        }
        list.innerHTML = "";
      };

      const scrollToResultsTop = () => {
        if (!results) {
          return;
        }

        // Get the top position of results and subtract 150px to scroll higher
        const resultsTop = results.getBoundingClientRect().top + window.pageYOffset - 150;
        
        // Ensure we don't scroll to a negative position
        const targetScroll = Math.max(0, resultsTop);

        // Use Lenis smooth scroll if available, otherwise use native smooth scroll
        if (window.SOJ_SMOOTH_SCROLL && window.SOJ_SMOOTH_SCROLL.lenis) {
          window.SOJ_SMOOTH_SCROLL.lenis.scrollTo(targetScroll, {
            duration: 0.8,
            easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
          });
        } else {
          window.scrollTo({
            top: targetScroll,
            behavior: "smooth",
          });
        }
      };

      const handleChange = () => {
        const plantingValue = plantingSelect ? plantingSelect.value : "";
        const sectorValue = sectorSelect ? sectorSelect.value : "";

        const formData = new FormData();
        formData.append("action", action);
        formData.append("nonce", nonce);
        formData.append("planting", plantingValue);
        formData.append("sector", sectorValue);

        results.classList.add("is-loading");

        // Scroll to top of results when filter changes
        scrollToResultsTop();

        fetch(ajaxUrl, {
          method: "POST",
          credentials: "same-origin",
          body: formData,
        })
          .then((response) => {
            if (!response.ok) {
              throw new Error(
                `Network response was not ok (${response.status})`
              );
            }
            return response.json();
          })
          .then((data) => {
            if (!data || !data.success) {
              throw new Error(data?.data || "Unexpected response");
            }

            const html = data.data.html || "";
            list.innerHTML = html;
            setEmptyState(Boolean(data.data.found && html.trim().length > 0));
            applyParallax();
          })
          .catch(handleError)
          .finally(() => {
            results.classList.remove("is-loading");
          });
      };

      if (plantingSelect) {
        plantingSelect.addEventListener("change", handleChange);
      }
      if (sectorSelect) {
        sectorSelect.addEventListener("change", handleChange);
      }

      // Handle filter visibility based on results viewport
      const filters = block.querySelector(".projects__filters");
      if (filters && results) {
        const handleFilterVisibility = () => {
          const resultsRect = results.getBoundingClientRect();
          const viewportHeight = window.innerHeight;
          
          // getBoundingClientRect() returns coordinates relative to viewport
          // resultsRect.bottom < 0 means bottom of results is above viewport (scrolled past)
          // resultsRect.top > viewportHeight means top of results is below viewport (not scrolled to yet)
          
          // Hide filter if we've scrolled past the results section
          // (when the bottom of results is above the top of viewport)
          const isScrolledPast = resultsRect.bottom < 0;
          
          // Show filter if results is visible in viewport or we haven't scrolled to it yet
          const isResultsVisible = resultsRect.top < viewportHeight && resultsRect.bottom > 0;
          const notScrolledToYet = resultsRect.top > viewportHeight;

          if (isScrolledPast) {
            // Scrolled past - hide filter
            filters.classList.add("is-hidden");
          } else {
            // Results is visible or not scrolled to yet - show filter
            filters.classList.remove("is-hidden");
          }
        };

        // Use scroll event with throttling for responsive behavior
        let ticking = false;
        const onScroll = () => {
          if (!ticking) {
            window.requestAnimationFrame(() => {
              handleFilterVisibility();
              ticking = false;
            });
            ticking = true;
          }
        };

        // Always attach to both Lenis and window scroll to ensure it works
        // Lenis scroll event (for smooth scroll)
        if (window.SOJ_SMOOTH_SCROLL && window.SOJ_SMOOTH_SCROLL.lenis) {
          window.SOJ_SMOOTH_SCROLL.lenis.on("scroll", onScroll);
        }
        
        // Window scroll event (fallback and for when Lenis isn't active)
        window.addEventListener("scroll", onScroll, { passive: true });

        // Initial check
        handleFilterVisibility();
        
        // Also check on resize in case viewport changes
        window.addEventListener("resize", handleFilterVisibility, { passive: true });
      }

      applyParallax();
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initProjects);
  } else {
    initProjects();
  }
})();
